<template>
  <div class="lx-toolbar" role="group" aria-label="Export">
    <button type="button" class="lx-btn lx-btn--primary" :disabled="busy" title="Excel workbook built in the browser: Inputs · Forecast · Intervals · Metrics · Drivers · Metadata (only sheets with data)" @click="run('excel-client')">
      <v-icon size="16">mdi-microsoft-excel</v-icon> Export Excel
    </button>
    <button type="button" class="lx-btn" :disabled="busy" title="Legacy server-side export of the input and output tables (opens the file URL returned by the backend)" @click="run('excel-server')">
      Server export (legacy)
    </button>
    <button type="button" class="lx-btn" :disabled="busy || !chartAvailable" :title="clipboardSupported ? 'Render the chart locally and copy it as PNG to the clipboard' : 'Clipboard images are not supported in this browser; use Download PNG'" @click="run('png-copy')">
      <v-icon size="16">mdi-content-copy</v-icon> Copy chart as PNG
    </button>
    <button type="button" class="lx-btn" :disabled="busy || !chartAvailable" title="Download the chart as PNG (rendered locally)" @click="run('png-download')">
      <v-icon size="16">mdi-download</v-icon> Download PNG
    </button>
    <span v-if="message" class="lx-method" role="status" aria-live="polite">{{ message }}</span>
  </div>
</template>

<script>
export default {
  name: "ForecastExportMenu",
  props: {
    chartAvailable: { type: Boolean, default: false },
    busy: { type: Boolean, default: false },
    message: { type: String, default: "" },
  },
  emits: ["action"],
  computed: {
    clipboardSupported() {
      return typeof window !== "undefined" && !!(navigator.clipboard && window.ClipboardItem);
    },
  },
  methods: {
    run(action) {
      this.$emit("action", action);
    },
  },
};
</script>
